export const SHARED_ENDPOINTS = {
    CATEGORIES: '/api/v1/categories'
};

// unique query keys for each API
export enum SharedEndpointQueryKeys {
    GET_CATEGORIES = 'get-user-categories'
}